import { useEffect, useState } from 'react';
import { getExchangeRateForDate } from '../services/exchangeRateService';

export function useExchangeRateForDate(issueDate) {
  const [saleRate, setSaleRate] = useState(null);
  const [rateDate, setRateDate] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!issueDate) {
      setSaleRate(null);
      setRateDate(null);
      return;
    }
    let cancelled = false;
    setLoading(true);
    getExchangeRateForDate(issueDate)
      .then((res) => {
        if (cancelled) return;
        if (res?.success && res.data?.sale_rate) {
          setSaleRate(Number(res.data.sale_rate));
          setRateDate(res.data.rate_date);
        } else {
          setSaleRate(null);
          setRateDate(null);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setSaleRate(null);
          setRateDate(null);
        }
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [issueDate]);

  return { saleRate, rateDate, loading };
}
